const MIN_OTHER_LENGTH = 10;

function buildModal(reasons, title) {
    const overlay = document.createElement('div');
    overlay.className = 'ms-modal nm-report-modal-overlay';
    overlay.innerHTML = ''
        + '<div class="ms-modal__dialog nm-report-modal" role="dialog" aria-modal="true" aria-label="' + escapeAttr(title) + '">'
        + '  <header class="ms-modal__head">'
        + '    <h3 class="ms-modal__title">' + escapeHtml(title) + '</h3>'
        + '    <button type="button" class="ms-modal__close nm-report-modal__close" data-report-close aria-label="Zamknij">×</button>'
        + '  </header>'
        + '  <form class="ms-modal__body nm-report-modal__body" data-report-form>'
        + '    <fieldset class="nm-report-modal__reasons">'
        + '      <legend>Wybierz powód zgłoszenia</legend>'
        +        reasons.map((r, i) => ''
                 + '<label class="nm-report-modal__reason">'
                 + '  <input type="radio" name="reason_code" value="' + escapeAttr(r.code) + '"' + (i === 0 ? ' required' : '') + ' />'
                 + '  <span>' + escapeHtml(r.label) + '</span>'
                 + '</label>'
                 ).join('')
        + '    </fieldset>'
        + '    <label class="nm-report-modal__other" data-report-other hidden>'
        + '      <span>Opisz powód (minimum 10 znaków)</span>'
        + '      <textarea class="ms-textarea" name="reason_other_text" rows="3" minlength="' + MIN_OTHER_LENGTH + '" maxlength="1000"></textarea>'
        + '    </label>'
        + '    <div class="nm-report-modal__error" data-report-error hidden role="alert"></div>'
        + '    <div class="nm-report-modal__actions">'
        + '      <button type="button" class="ms-button ms-button--secondary ms-button--block nm-secondary-btn" data-report-close>Anuluj</button>'
        + '      <button type="submit" class="ms-button ms-button--primary ms-button--block nm-primary-btn" data-report-submit disabled>Wyślij zgłoszenie</button>'
        + '    </div>'
        + '  </form>'
        + '</div>';
    return overlay;
}

function escapeHtml(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c])); }
function escapeAttr(v) { return escapeHtml(v); }

function closeModal(overlay) {
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
}

function showError(overlay, message) {
    const el = overlay.querySelector('[data-report-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
}

export function createSignalReportModule(options) {
    const opts = options || {};
    const apiUrl = opts.apiUrl || '/rcn/api/community-signals';
    const loginUrl = opts.loginUrl || '/konto/logowanie';
    const dashboardUrl = opts.dashboardUrl || '/konto/panel/moje-zgloszenia';
    const reasons = Array.isArray(opts.reasons) ? opts.reasons : [];
    const title = opts.title || 'Zgłoś sygnał do moderacji';
    const selector = opts.selector || '[data-signal-report]';
    const idAttribute = opts.idAttribute || 'data-signal-id';

    function requestUrl(itemId) {
        if (typeof opts.requestUrl === 'function') {
            return opts.requestUrl(itemId);
        }
        return apiUrl + '/' + encodeURIComponent(itemId) + '/report';
    }

    function buildPayload(itemId, payload) {
        if (typeof opts.buildPayload === 'function') {
            return opts.buildPayload(itemId, payload);
        }
        return payload;
    }

    async function openModal(signalId) {
        const overlay = buildModal(reasons, title);
        document.body.appendChild(overlay);

        const form = overlay.querySelector('[data-report-form]');
        const submitBtn = overlay.querySelector('[data-report-submit]');
        const otherField = overlay.querySelector('[data-report-other]');
        const textarea = overlay.querySelector('textarea[name="reason_other_text"]');

        function update() {
            const checked = form.querySelector('input[name="reason_code"]:checked');
            const isOther = checked && checked.value === 'other';
            otherField.hidden = !isOther;
            const otherText = textarea ? textarea.value.trim() : '';
            const valid = !!checked && (!isOther || otherText.length >= MIN_OTHER_LENGTH);
            submitBtn.disabled = !valid;
        }

        form.addEventListener('change', update);
        form.addEventListener('input', update);

        overlay.addEventListener('click', (ev) => {
            if (ev.target === overlay || ev.target.matches('[data-report-close]')) {
                closeModal(overlay);
            }
        });

        document.addEventListener('keydown', function onKey(ev) {
            if (ev.key === 'Escape') {
                closeModal(overlay);
                document.removeEventListener('keydown', onKey);
            }
        });

        form.addEventListener('submit', async (ev) => {
            ev.preventDefault();
            submitBtn.disabled = true;
            showError(overlay, '');

            const checked = form.querySelector('input[name="reason_code"]:checked');
            const payload = buildPayload(signalId, {
                reason_code: checked ? checked.value : '',
                reason_other_text: textarea ? textarea.value : '',
            });

            try {
                const res = await fetch(requestUrl(signalId), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    credentials: 'same-origin',
                    body: JSON.stringify(payload),
                });

                if (res.status === 401) {
                    const back = encodeURIComponent(location.pathname + location.search + location.hash);
                    window.location.href = loginUrl + '?returnUrl=' + back;
                    return;
                }
                if (res.status === 403) {
                    const data = await res.json().catch(() => ({}));
                    showError(overlay, data.error || 'Brak dostępu.');
                    submitBtn.disabled = false;
                    return;
                }
                if (res.status === 409) {
                    showError(overlay, 'To zgłoszenie zostało już wysłane. Zobacz je w panelu użytkownika.');
                    submitBtn.disabled = false;
                    return;
                }
                if (res.status === 429) {
                    showError(overlay, 'Przekroczono dzienny limit zgłoszeń.');
                    submitBtn.disabled = false;
                    return;
                }
                if (!res.ok) {
                    const data = await res.json().catch(() => ({}));
                    showError(overlay, data.error || 'Nie udało się wysłać zgłoszenia.');
                    submitBtn.disabled = false;
                    return;
                }
                closeModal(overlay);
                if (typeof opts.onSuccess === 'function') opts.onSuccess();
            } catch (e) {
                showError(overlay, 'Błąd sieci. Spróbuj ponownie.');
                submitBtn.disabled = false;
            }
        });

        update();
    }

    document.addEventListener('click', (ev) => {
        const btn = ev.target.closest(selector);
        if (!btn) return;
        ev.preventDefault();
        ev.stopPropagation();
        const signalId = btn.getAttribute(idAttribute);
        if (!signalId) return;
        openModal(signalId);
    });

    return { openModal };
}
